
<cvt-dialog :show="visible" :hide-borders="true" @close="close">
  <div class="integrations-wrapper">
    <IntegrationsTemplate :input-full-width="true" />
  </div>
</cvt-dialog>
